// @ts-check

/**
 * @returns {{ Notifications: { checkForEmailConfirmation: boolean } }}
 */
export const checkForEmailConfirmation = () => ({
  Notifications: {
    checkForEmailConfirmation: true,
  },
})

/**
 * @param {string} notificationID
 * @returns {{ Notifications: { setNotificationAsSeen: boolean, notificationID: string } }}
 */
export const setNotificationAsSeen = (notificationID) => ({
  Notifications: {
    setNotificationAsSeen: true,
    notificationID: notificationID,
  },
})

/**
 * @param {string[]} ids
 * @returns {{ Notifications: { setNotificationsAsSeen: boolean, notificationIDs: string[] } }}
 */
export const setNotificationsAsSeen = (ids) => ({
  Notifications: {
    setNotificationsAsSeen: true,
    notificationIDs: ids,
  },
})

/**
 * @param {string} notificationID
 * @returns {{ Notifications: { removeNotification: boolean, notificationID: string } }}
 */
export const removeNotification = (notificationID) => ({
  Notifications: {
    removeNotification: true,
    notificationID: notificationID,
  },
})

/**
 * @returns {{ Notifications: { getAccountNotifications: boolean } }}
 */
export const getAllAccountNotifications = () => ({
  Notifications: {
    getAccountNotifications: true,
  },
})

/**
 * @returns {{ Notifications: { checkForProfileNotifications: boolean } }}
 */
export const getActiveAccountNotifications = () => ({
  Notifications: {
    checkForProfileNotifications: true,
  },
})
